import type { RailwayProjectSummary, RailwayRunner } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'
import { isDeletedRailwayProject } from './is-deleted-railway-project.js'
import { parseProjectSummary } from './parse-project-summary.js'

export async function listRailwayProjects(
  runner: RailwayRunner,
  cwd: string,
  env?: NodeJS.ProcessEnv
): Promise<RailwayProjectSummary[]> {
  const result = await runRailway(runner, ['project', 'list', '--json'], {
    cwd,
    mode: 'capture',
    env
  })
  if (!result.success) {
    throw new Error(
      outputTail(`${result.stdout}\n${result.stderr}`) ?? 'Could not list Railway projects.'
    )
  }

  const payload = parseRailwayJson<unknown>(result.stdout)
  if (!Array.isArray(payload)) {
    throw new Error('Railway returned an invalid project list response.')
  }

  const projects = payload
    .filter((project) => !isDeletedRailwayProject(project))
    .map(parseProjectSummary)
  if (projects.some((project) => !project)) {
    throw new Error('Railway returned an invalid project list response.')
  }

  return projects as RailwayProjectSummary[]
}
